import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";

import image1 from "../../../images/gear/gera-oil/8605/8605_1front.webp";
import image2 from "../../../images/gear/gera-oil/8605/8605_1back.webp";



const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },

];

const packageSlides = [
  { images: [image1, image2] },
 

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/150";


const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF8605_-_FANFARO 8605 ATF SP-IV_(SK).pdf" }
];





export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://kytecarparts.com/products/fanfaro-8605-automatic-transmission-fluid?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy Now
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO ATF SP-IV 8605</h2>

        <p>
          Special low viscosity synthetic gear oil (ATF) with a special additive package for Hyundai 6-speed automatic transmissions. Designed based on the requirements of Korean automakers.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
          <li> A low-viscosity synthetic base of the highest quality with a consistently high viscosity index in combination with a multifunctional additive package retains all its properties in a wide temperature range: it provides good lubricating properties at low (-45 °C) temperatures in winter and provides a stable oil film at extreme loads and temperatures in the summer, it provides the necessary anti-friction properties even in case of violation of the continuity of the oil film under heavy loads. Protects friction surfaces from wear and sticking, reduces friction energy losses.</li>
          <li>A high-tech combination of additives provides good anti-friction properties for gearing and excellent frictional properties for friction elements, which ensures significant fuel economy, exceptionally soft and smooth gearshifts without jerking and a significant increase in the service life of all transmission elements.</li>
          <li>Provides smooth and reliable operation of the clutches, extends the service life of friction elements, prevents slipping of the contacting elements of the torque converter when switching modes, which significantly reduces their wear.</li>
          <li> It has unsurpassed thermal oxidative and chemical stability and resistance to high-temperature thermal degradation over the entire life cycle. This allows to minimize the formation of sludge, varnish, soot and other carbon deposits, significantly increase the oil change interval and ensure the durability of transmission parts, which reduces the cost of maintenance.</li>
          <li> Protects metal parts from ferrous and non-ferrous alloys from corrosion both during operation and inoperative.</li>
          <li>Effectively resists aeration and foaming.</li>
          <li>Provides compatibility with all materials of seals, prevents their swelling, hardening and shrinkage, which reduces the cost of spare parts and prevents leaks.</li>
          <li> Well removes heat from rubbing surfaces.</li>
          <li>Reduces noise.</li>
        </ul> <br />

        <p>
         It is recommended for automatic transmissions of HYUNDAI, KIA of the latest generation where compliance with the above requirements is required, as well as for automatic transmissions of cars and commercial vehicles of European manufacturers in accordance with the above specifications. Suitable for gearboxes of Proton and Chery cars. <br />

         Color: red. <br />
        Follow the manufacturer's instructions in the instruction manual!
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>JASO M315, Class 1-A-LV</li>
              
            </ul>
          </div>


          <div>
            <b>Recommendation</b>

<ul style={{ paddingLeft: "20px" }}>
  <li>ACURA DW-1</li>
  <li>ACURA ATF Type 3.0</li>
  <li>ACURA ATF Type 3.1</li>
  <li>BENTLEY PY112995PA</li>
  <li>BMW 83 22 0 142 516 (1375.4)</li>
  <li>BMW 83 22 0 397 114</li>
  <li>BMW 83 22 2 152 426</li>
  <li>BMW 83 22 2 289 720</li>
  <li>BMW 83 22 2 163 514</li>
  <li>BMW 83 22 2 305 397</li>
  <li>CHRYSLER 05127382AA</li>
  <li>CHRYSLER 68157995AA</li>
  <li>DODGE 68043742AA</li>
  <li>DODGE 68157995AA</li>
  <li>FORD XT-10-QLVC</li>
  <li>FORD XT-6-QSP</li>
  <li>FORD XT-6-DSP</li>
  <li>HONDA DW-1</li>
  <li>HONDA ATF Type 3.0</li>
  <li>HONDA ATF Type 3.1</li>
  <li>HYUNDAI NWS-9638 T-5</li>
  <li>HYUNDAI SP-IV</li>
  <li>HYUNDAI SPH-IV</li>
  <li>HYUNDAI SP-IV-RR</li>
  <li>INFINITI Matic S</li>
  <li>INFINITI Matic W</li>
  <li>JAGUAR Fluid 8432</li>
  <li>JEEP 05127382AA</li>
  <li>JEEP 68043742AA</li>
  <li>JEEP 68157995AA</li>
  <li>KIA NWS-9638 T-5</li>
  <li>KIA SP-IV</li>
  <li>KIA SPH-IV</li>
  <li>KIA SP-IV-RR</li>
  <li>LAND ROVER TYK500050</li>
  <li>LAND ROVER LR0022460</li>
  <li>LEXUS Scion FZ</li>
  <li>LEXUS Type WS</li>
  <li>LEXUS JWS 3324</li>
  <li>LINCOLN XT-10-QLVC</li>
  <li>LINCOLN XT-6-QSP</li>
  <li>LINCOLN XT-6-DSP [SP]</li>
  <li>MASERATI 231603</li>
  <li>MAZDA FZ</li>
  <li>MAZDA FW 6A EL</li>
  <li>MAZDA FW 6AX EL</li>
  <li>MB 236.12</li>
  <li>MB 236.14</li>
  <li>MB 236.41</li>
  <li>MERCURY XT-10-QLVC</li>
  <li>MERCURY XT-6-QSP</li>
  <li>MINI 83 22 0 142 516</li>
  <li>MINI 83 22 0 397 114</li>
  <li>MINI 83 22 2 152 426</li>
  <li>MINI 83 22 2 289 720</li>
  <li>MINI 83 22 2 163 514</li>
  <li>MINI 83 22 2 305 397</li>
  <li>MITSUBISHI ATF-J3</li>
  <li>MITSUBISHI Dia Queen ATF-PA</li>
  <li>NISSAN Matic S</li>
  <li>NISSAN Matic W</li>
  <li>OPEL GM SATURN GMC AW1-VI</li>
  <li>OPEL GM SATURN GMC 88863400</li>
  <li>OPEL GM SATURN GMC 88863401</li>
  <li>PORSCHE 000 043 304 00</li>
  <li>SAAB 93 165 147 AW-1</li>
  <li>TOYOTA Scion FZ</li>
  <li>TOYOTA Type WS (JWS 3324)</li>
  <li>ZF Lifeguardfluid 6</li>
  <li>HYUNDAI SP4-M1</li>
  <li>HYUNDAI 040000C90SG</li>
  <li>KIA 040000C90SG</li>
  <li>KIA SP4-M1</li>
  <li>MERCURY XT-6-DSP</li>
  <li>MITSUBISHI Dia Queen ATF-MA1 MZ320775</li>
  <li>ZF Lifeguardfluid 8</li>
</ul>
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF8605-1)
                </span>
              </li>

              {/* <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li> */}

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/150"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}